export const clamp = (v: number, lo: number, hi: number): number => (v < lo ? lo : v > hi ? hi : v);
export const lerp = (a: number, b: number, t: number): number => a + (b - a) * t;
export const smoothstep = (t: number): number => t * t * (3 - 2 * t);
export const TAU = Math.PI * 2;

export interface Vec2 {
  x: number;
  y: number;
}

export function len(x: number, y: number): number {
  return Math.hypot(x, y);
}

/** Shortest signed angular difference from a to b, in radians. */
export function angleDelta(a: number, b: number): number {
  let d = (b - a) % TAU;
  if (d > Math.PI) d -= TAU;
  if (d < -Math.PI) d += TAU;
  return d;
}

/** Compass label for a wind *direction of travel* in screen space (up-screen = uphill = N). */
export function compass(dirRad: number): string {
  // Screen space: +x right (E), +y down (S). Wind blowing up-screen is northward.
  const deg = (((Math.atan2(-Math.sin(dirRad), Math.cos(dirRad)) * 180) / Math.PI) + 360) % 360;
  const names = ['E', 'NE', 'N', 'NW', 'W', 'SW', 'S', 'SE'];
  return names[Math.round(deg / 45) % 8];
}
